// The design system's component bundle (window.Wahala), and a React wrapper for its HTML strings.
// The bundle escapes every name it is given; strings from the server go in as data, never markup.
import '../ds/bundle.js';
import { type CSSProperties, type MouseEvent, type Ref, useMemo } from 'react';

export const W = () => window.Wahala;

export function Html({
  html,
  className,
  style,
  onClick,
  ref,
}: {
  ref?: Ref<HTMLDivElement>;
  html: string;
  className?: string;
  style?: CSSProperties;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}) {
  // React 19 compares this prop by object, not by string: a fresh object on every render would
  // rebuild the markup each time (flicker, and a tap landing on a button just replaced). One object
  // per distinct string keeps the DOM until the markup really changes.
  const inner = useMemo(() => ({ __html: html }), [html]);
  // The bundle escapes what it is given. Clicks are delegated from the real <button>s inside the
  // markup, which keyboards and screen readers already reach.
  return (
    // biome-ignore lint/security/noDangerouslySetInnerHtml: escaped design-system markup by contract
    // biome-ignore lint/a11y/noStaticElementInteractions: delegation from inner buttons
    // biome-ignore lint/a11y/useKeyWithClickEvents: inner buttons handle the keyboard
    <div ref={ref} className={className} style={style} onClick={onClick} dangerouslySetInnerHTML={inner} />
  );
}
